<template>
  <div class="userIndex">
    <div class="left">
      <ul>
        <template class="box">
          <li 
          v-for="(item,index) in navList" 
          :key="item.id" 
          @click="changeNav(index)"
          :class="index == currentNav ? 'active' : $route.query.type == 'add' ? 'noclick' : ''">{{item}}</li>
        </template>
      </ul>
    </div>
    <div class="right">
      <BaseSet v-if="currentNav == 0"></BaseSet>
      <SecuritySet v-if="currentNav == 1"></SecuritySet>
    </div>
    
  </div>
</template>

<script>

import BaseSet from "./components/BaseSet";
import SecuritySet from "./components/SecuritySet";
export default {
  name:'userIndex',
  components: { BaseSet , SecuritySet },
  data () {
    return {
      navList:['基本设置','安全设置'],
      currentNav:0,
    }
  },
  methods: {
    changeNav(index){
      if(this.$route.query.type == 'add'){
        if(index == 0){
          this.currentNav = index
        }else{
          return
        }
      }else{
        this.currentNav = index
      }
    },
    
  }
}
</script>

<style scoped lang="less">
.userIndex{
  min-height: 400px;
  padding: 5px 0;
  display: flex;
  width: 100%;
  background-color: #fff;
  .left{
    width: 15%;
    border-right:1px solid #f2f2f2;
    ul{
      width: 100%;
      padding: 0;
      li{
        list-style: none;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .active{
        background: rgb(230,247,255);
        color:#1890ff;
        border-right:4px solid #1890ff;
      }
      .noclick{
        cursor: not-allowed;
        background: #f4f4f4;
        opacity: 0.6;
      }
    }
  }
  .right{
    flex: 1;
    padding: 10px 20px;
  }
}
</style>
